module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/common/icon_i02-fed07fb1f9ce983a26301f12ed57cade.svg";